module.exports = __webpack_public_path__ + "static/media/26.6fbdc93d.mp3";